import { Organisation, Event, EventDivision, Division, FormatDefinition } from "graphql/generated/types";

const MAXIMUM_ITEMS = 9;
const LOCAL_STORAGE_KEY = "recentlyViewed";


export interface RecentlyViewedEventData extends Pick<Event, "id" | "name" | "status" | "date" | "daysWindow"> {
    organisation: Pick<Organisation, "name" | "logo" | "sportType">
}

export interface RecentlyViewedEvent {
    type: "event",
    data: RecentlyViewedEventData
}

export interface RecentlyViewedEventDivisionData extends Pick<EventDivision, "id" | "eventDivisionId" | "entryCount"> {
    division: Pick<Division, "name">
    event: Pick<Event, "id" | "name">
    formatDefinition: Pick<FormatDefinition, "isTeams">
}

export interface RecentlyViewedEventDivision {
    type: "eventDivision"
    data: RecentlyViewedEventDivisionData
}

export interface RecentlyViewedRankingsData {
    seriesId: string,
    seriesName: string,
    divisionId: string,
    divisionName: string,
    organisation: Pick<Organisation, "name" | "logo" | "sportType" | "shortName" >
}

export interface RecentlyViewedRankings {
    type: "rankings",
    data: RecentlyViewedRankingsData
}

export type RecentlyViewedItem = RecentlyViewedEvent | RecentlyViewedEventDivision | RecentlyViewedRankings

interface UseRecentlyViewedResult {
    addItem: (item: RecentlyViewedItem) => void;
    items: RecentlyViewedItem[];
}

const itemKey = (item: RecentlyViewedItem) => {
    const { type, data } = item;
    if (type === "event") return `event-${data.id}`;
    if (type === "eventDivision") return `eventDivision-${data.id}`;
    if (type === "rankings") return `rankings-${data.seriesId}-${data.divisionId}`;
    throw new Error(`Unknown item type: ${type}`);
};

export const useRecentlyViewed = (): UseRecentlyViewedResult  => {
    const getItems = () => {
        return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "[]") as RecentlyViewedItem[];
    };

    const addItem = (item :RecentlyViewedItem) => {
        const items = getItems();
        const existing = items.findIndex((el) => itemKey(el) === itemKey(item));
        if (existing != -1) {
            items.splice(existing, 1);
        }

        items.unshift(item);
        items.splice(MAXIMUM_ITEMS);

        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(items));
    };

    try {
        return { items: getItems(), addItem };
    } catch (error) {
        console.warn("Error parsing recently viewed items from localStorage", error);
        return { items: [], addItem };
    }
};
